// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersFacultyMobile_filters-faculty-mobile__0s\\+lm {
  display: flex;
  gap: 8px;
  align-items: center;
}
.FiltersFacultyMobile_filters-faculty-mobile__0s\\+lm .FiltersFacultyMobile_filter-trigger__c3YwN svg {
  border: 1px solid var(--secondary-color);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 5px;
}
.FiltersFacultyMobile_filters-faculty-mobile__0s\\+lm .FiltersFacultyMobile_filter-trigger__c3YwN svg path {
  stroke: var(--secondary-color);
  stroke-width: 1px;
}

.ant-drawer-footer .FiltersFacultyMobile_filters-footer__XKNDM {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.ant-drawer-footer .FiltersFacultyMobile_filters-footer__XKNDM .FiltersFacultyMobile_apply-button__8rMeE {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: black;
  color: white;
  cursor: pointer;
}
.ant-drawer-footer .FiltersFacultyMobile_filters-footer__XKNDM .FiltersFacultyMobile_clear-button__YOXOG {
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
}

.ant-drawer-body .FiltersFacultyMobile_title-filter__t\\+TOi {
  color: var(--public-profile-color);
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersFacultyMobile_title-sub-filter__EccW9 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersFacultyMobile_title-sub-filter-affiliation__VgoBj {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px !important;
}
.ant-drawer-body .FiltersFacultyMobile_search-sub-filter__Z4QFB {
  margin-top: 5px;
}
.ant-drawer-body .FiltersFacultyMobile_position__V8VOu {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersFacultyMobile_seniority__c0bif {
  margin-bottom: 15px;
}
.ant-drawer-body .FiltersFacultyMobile_sub-filter__VG7A9 {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyList/Components/FiltersFacultyMobile/FiltersFacultyMobile.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;AACI;EACE,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACN;AAAM;EACE,8BAAA;EACA,iBAAA;AAER;;AAKE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAFJ;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AADN;AAGI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AADN;;AAME;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAHJ;AAKE;EACE,eAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ","sourcesContent":[".filters-faculty-mobile {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  .filter-trigger {\n    svg {\n      border: 1px solid var(--secondary-color);\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      padding: 5px;\n      path {\n        stroke: var(--secondary-color);\n        stroke-width: 1px;\n      }\n    }\n  }\n}\n\n:global(.ant-drawer-footer) {\n  .filters-footer {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    .apply-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      background: black;\n      color: white;\n      cursor: pointer;\n    }\n    .clear-button {\n      width: 100px;\n      height: 40px;\n      border-radius: 10px;\n      border: none;\n      cursor: pointer;\n      margin-right: 10px;\n    }\n  }\n}\n:global(.ant-drawer-body) {\n  .title-filter {\n    color: var(--public-profile-color);\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .title-sub-filter-affiliation {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 10px !important;\n  }\n  .search-sub-filter {\n    margin-top: 5px;\n  }\n  .position {\n    margin-bottom: 15px;\n  }\n  .seniority {\n    margin-bottom: 15px;\n  }\n  .sub-filter {\n    margin-bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-faculty-mobile": `FiltersFacultyMobile_filters-faculty-mobile__0s+lm`,
	"filter-trigger": `FiltersFacultyMobile_filter-trigger__c3YwN`,
	"filters-footer": `FiltersFacultyMobile_filters-footer__XKNDM`,
	"apply-button": `FiltersFacultyMobile_apply-button__8rMeE`,
	"clear-button": `FiltersFacultyMobile_clear-button__YOXOG`,
	"title-filter": `FiltersFacultyMobile_title-filter__t+TOi`,
	"title-sub-filter": `FiltersFacultyMobile_title-sub-filter__EccW9`,
	"title-sub-filter-affiliation": `FiltersFacultyMobile_title-sub-filter-affiliation__VgoBj`,
	"search-sub-filter": `FiltersFacultyMobile_search-sub-filter__Z4QFB`,
	"position": `FiltersFacultyMobile_position__V8VOu`,
	"seniority": `FiltersFacultyMobile_seniority__c0bif`,
	"sub-filter": `FiltersFacultyMobile_sub-filter__VG7A9`
};
export default ___CSS_LOADER_EXPORT___;
